/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray, extends as _extends, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import { ComboBox } from '@carbon/react';
import { useTranslation } from '../../../../Utilities/i18n/i18n.js';
import _translateWithId from '../../EnhancedDataTable/misc/translation.js';

var _excluded = ["columnKey", "initialSelectedItem", "onChange", "items", "mode", "allowInputAsItem"];

/* eslint-disable react/prop-types */

var hoc = function hoc(WrappedComponent) {
  return function (_ref) {
    var _initialSelectedItem$;
    var columnKey = _ref.columnKey,
      initialSelectedItem = _ref.initialSelectedItem,
      onChange = _ref.onChange,
      items = _ref.items,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'live' : _ref$mode,
      _ref$allowInputAsItem = _ref.allowInputAsItem,
      allowInputAsItem = _ref$allowInputAsItem === void 0 ? false : _ref$allowInputAsItem,
      passthroughProps = _objectWithoutProperties(_ref, _excluded);
    var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      input = _useState2[0],
      setInput = _useState2[1];
    var _useTranslation = useTranslation(),
      t = _useTranslation.t;
    var onInputChange = function onInputChange(inputValue) {
      setInput(inputValue);
    };
    var augmentedOnChange = function augmentedOnChange(args) {
      onChange(_objectSpread2(_objectSpread2({}, args), {}, {
        columnKey: columnKey,
        mode: mode
      }));
    };
    var shouldFilterItem = function shouldFilterItem(e) {
      if (!e.inputValue) {
        return true;
      }
      return e.item.label.toLowerCase().includes(e.inputValue.toLowerCase());
    };
    var augmentedInitialSelectedItem = initialSelectedItem === null || initialSelectedItem === void 0 || (_initialSelectedItem$ = initialSelectedItem[0]) === null || _initialSelectedItem$ === void 0 ? void 0 : _initialSelectedItem$.label;
    var augmentedItems = !allowInputAsItem || !input ? items : [{
      id: input,
      label: input
    }].concat(_toConsumableArray(items));
    return /*#__PURE__*/React.createElement(WrappedComponent
    // eslint-disable-next-line react/jsx-props-no-spreading
    , _extends({}, passthroughProps, {
      translateWithId: function translateWithId(id) {
        return _translateWithId(id, t);
      },
      initialSelectedItem: augmentedInitialSelectedItem,
      items: augmentedItems,
      onChange: augmentedOnChange,
      shouldFilterItem: shouldFilterItem,
      onInputChange: onInputChange
    }));
  };
};
var TableToolbarComboBox = hoc(ComboBox);
var TableToolbarComboBox$1 = TableToolbarComboBox;

export { TableToolbarComboBox$1 as default };
